export interface DocumentItem {
  id: string;
  document_type_id: number;
  file_url: string;
  is_verified: boolean;
  type?: { code: string; name: string };
  created_at: string;
}

export interface DocumentState {
  documents: DocumentItem[] | null;
  loading: boolean;
  error: any;
}

export interface DocumentUploadFormState {
  file: File | null;
  documentTypeCode: string;
}

export const INITIAL_DOCUMENT_UPLOAD_STATE: DocumentUploadFormState = {
  file: null,
  documentTypeCode: "PANCR" // Default type
};